import axios from "axios";
import config from "../config/config";
import { getHeaders } from "./apiHelper";

const API_URL = config.API_URL; 

export const getReward = async () => {
  const response = await axios.get(`${API_URL}rule`, { headers: getHeaders() });
  return response.data;
};

export const storeReward = async (reward) => {
  const isMultipart = typeof FormData !== 'undefined' && reward instanceof FormData;
  const response = await axios.post(`${API_URL}rule`, reward, { headers: getHeaders(isMultipart) });
  return response.data;
};

export const getDetailReward = async (id) => {
  const response = await axios.get(`${API_URL}rule/${id}`, { headers: getHeaders() });
  return response.data;
};

export const deleteReward = async (id) => {
  const response = await axios.delete(`${API_URL}rule/${id}`, { headers: getHeaders() });
  return response.data;
};

export const updateReward = async (id, data) => {
  const isMultipart = typeof FormData !== 'undefined' && data instanceof FormData;
  if (isMultipart) {
    if (!data.has('_method')) {
      data.append('_method', 'PUT');
    }
    const response = await axios.post(`${API_URL}rule/${id}`, data, { headers: getHeaders(true) });
    return response.data;
  }
  const response = await axios.put(`${API_URL}rule/${id}`, data, { headers: getHeaders(false) });
  return response.data;
};

export const cloneReward = async (id) => {
  const response = await axios.post(`${API_URL}rule/${id}/clone`, null, { headers: getHeaders() });
  return response.data;
};

export const toggleRewardStatus = async (id) => {
  const response = await axios.put(`${API_URL}rule/${id}/toggle`, null, { headers: getHeaders() });
  return response.data;
};

export const getUser = async () => {
  const response = await axios.get(`${API_URL}user`, { headers: getHeaders() });
  return response.data;
};

export const getDivision = async () => {
  const response = await axios.get(`${API_URL}division`, { headers: getHeaders() });
  return response.data;
};
